import { useState } from 'react';
import { NJButton, NJHeading } from '@engie-group/fluid-design-system-react';
import { RightSideModal } from './RightSideModalFixed';

interface ContractCreateModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (data: ContractFormData) => void;
}

interface ContractFormData {
    name: string;
    type: 'electricity' | 'water' | 'gas';
    defaultPrice: number;
    peakHours: string;
}

const INPUT_STYLE: React.CSSProperties = {
    width: '100%', minHeight: 40, padding: '10px 12px',
    border: '1px solid var(--nj-semantic-color-border-neutral-minimal-default)',
    borderRadius: 4, fontSize: 14, boxSizing: 'border-box',
};

const LABEL_STYLE: React.CSSProperties = {
    display: 'block', fontSize: 14, marginBottom: 6,
};

export function ContractCreateModal({ isOpen, onClose, onSubmit }: ContractCreateModalProps) {
    const [formData, setFormData] = useState<ContractFormData>({
        name: '',
        type: 'electricity',
        defaultPrice: 0.15,
        peakHours: '08:00-20:00',
    });

    const handleSubmit = () => {
        if (!formData.name) {
            alert('Veuillez remplir tous les champs obligatoires');
            return;
        }
        onSubmit(formData);
        setFormData({ name: '', type: 'electricity', defaultPrice: 0.15, peakHours: '08:00-20:00' });
    };

    return (
        <RightSideModal
            isOpen={isOpen}
            onClose={onClose}
            title="Créer un contrat"
            metadata={<>Créé par PROTOTYPER le {new Date().toLocaleDateString('fr-FR')}</>}
            footer={
                <>
                    <NJButton label="Annuler" emphasis="subtle" onClick={onClose} />
                    <NJButton label="Créer" emphasis="bold" onClick={handleSubmit} />
                </>
            }
        >
            {/* Section: Informations générales */}
            <div style={{ marginBottom: 24 }}>
                <NJHeading as="h4" scale="sm" style={{ marginBottom: 16 }}>
                    Informations générales
                </NJHeading>

                <div style={{ marginBottom: 16 }}>
                    <label style={LABEL_STYLE}>Nom du contrat *</label>
                    <input
                        type="text"
                        value={formData.name}
                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                        placeholder="Contrat électricité Bercy"
                        style={INPUT_STYLE}
                    />
                    <span style={{ fontSize: 12, color: 'var(--nj-semantic-color-text-neutral-tertiary-default)', marginTop: 4, display: 'block' }}>
                        {formData.name.length}/64
                    </span>
                </div>

                <div style={{ marginBottom: 16 }}>
                    <label style={LABEL_STYLE}>Type de contrat *</label>
                    <select
                        value={formData.type}
                        onChange={(e) => setFormData({ ...formData, type: e.target.value as ContractFormData['type'] })}
                        style={INPUT_STYLE}
                    >
                        <option value="electricity">Électricité</option>
                        <option value="water">Eau</option>
                        <option value="gas">Gaz</option>
                    </select>
                </div>
            </div>

            {/* Section: Tarification */}
            <div style={{ marginBottom: 24 }}>
                <NJHeading as="h4" scale="sm" style={{ marginBottom: 16 }}>
                    Tarification
                </NJHeading>

                <div style={{ marginBottom: 16 }}>
                    <label style={LABEL_STYLE}>Prix par défaut (€/kWh ou €/m³) *</label>
                    <input
                        type="number"
                        step="0.01"
                        value={formData.defaultPrice}
                        onChange={(e) => setFormData({ ...formData, defaultPrice: Number(e.target.value) })}
                        placeholder="0.15"
                        style={INPUT_STYLE}
                    />
                </div>

                <div style={{ marginBottom: 16 }}>
                    <label style={LABEL_STYLE}>Heures pleines</label>
                    <input
                        type="text"
                        value={formData.peakHours}
                        onChange={(e) => setFormData({ ...formData, peakHours: e.target.value })}
                        placeholder="08:00-20:00"
                        style={INPUT_STYLE}
                    />
                    <span style={{ fontSize: 12, color: 'var(--nj-semantic-color-text-neutral-tertiary-default)', marginTop: 4, display: 'block' }}>
                        Format: HH:MM-HH:MM
                    </span>
                </div>
            </div>
        </RightSideModal>
    );
}
